import * as core from '../../../../../../../core'

import { query } from './workstream-bar-chart.query'

export const RESOURCE = {
  payload: {
    alias: 'workstream.bar.chart',
    description: 'Bar chart of change impacts by workstream',
    name: 'Workstream Bar Chart',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
